import { Obj } from 'interface/common';
import { QUESTION_QUERY_LIST } from 'redux-saga/actions';
import { 
  QUESTION_QUERY_LIST_SUCCESS, 
  QUESTION_QUERY_LIST_FAILED, 
  QUESTION_ACTION_SUCCESS, 
  QUESTION_ACTION_FAILED 
} from './reducers';

export const queryQuestionList = (payload: Obj) => ({
  type: QUESTION_QUERY_LIST,
  response: {
    success: {
      type: QUESTION_QUERY_LIST_SUCCESS,
    },
    failure: {
      type: QUESTION_QUERY_LIST_FAILED,
    },
  },
  payload
});

export const actionQuestion = (type: string, payload: FormData) => ({
  type,
  response: {
    success: {
      type: QUESTION_ACTION_SUCCESS,
    },
    failure: {
      type: QUESTION_ACTION_FAILED,
    },
  },
  payload
});